import ServiceBase from './serviceBase';
import { EsrrSprTimelineContainer } from './types/EsrrSprTimeline';

class OperEsrrSprTimelineService extends ServiceBase {
  getRecords = async (operationId: number): Promise<EsrrSprTimelineContainer> =>
    this.get<EsrrSprTimelineContainer>(`OperationTimeline/EsrrSpr/${operationId}`);
}

const operEsrrSprTimelineService = new OperEsrrSprTimelineService();

export default operEsrrSprTimelineService;
